import React from 'react'

import Hero from '../../components/Hero/Hero';
import Beneficios from '../../components/Beneficios/Beneficios';
import CtasInferiores from '../../components/CtasInferiores/CtasInferiores';
import Historia from '../../components/Historia/Historia';
import UltimasNovedades from '../../components/UltimasNovedades/UltimasNovedades';
import ProductosDestacados from '../../components/Tienda/components/ProdDestacados/DestacadosController';
import ProductosOfertados from '../../components/Tienda/components/ProdOfertados/OfertasController';

const ProductosDestacadosHome = (props) => (
	<section className="container my-0 my-md-3">
		<ProductosDestacados
			{...props}
			title="Productos destacados"
			updateURL={(url) => props.history && (document.querySelector("html").scrollTo(0, 0) & props.history.push(url))}
		/>
	</section>
);

const ProductosOfertadosHome = (props) => (
	<section className="container my-0 my-md-3">
		<ProductosOfertados
			{...props}
			title="Ofertas destacadas"
			updateURL={(url) => props.history && (document.querySelector("html").scrollTo(0, 0) & props.history.push(url))}
		/>
	</section>
);

const Home = (props) => {
	document.querySelector('html').scrollTo(0, 0);
	return (
		<>
			<Hero />
			<Beneficios />
			<ProductosOfertadosHome {...props} />
			<ProductosDestacadosHome {...props} />
			<CtasInferiores />
			<UltimasNovedades />
			<Historia />
		</>
	);
}

export default Home;
